import { Star, Quote } from 'lucide-react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Michael R.',
      role: 'Crypto Trader',
      avatar: 'M',
      rating: 5,
      text: 'Fastest exchange I\'ve ever used. My BTC to ETH swap was complete in under 3 minutes. No registration, no hassle. Absolutely love it!',
      date: '2 days ago',
    },
    {
      name: 'Sarah L.',
      role: 'DeFi Enthusiast',
      avatar: 'S',
      rating: 5,
      text: 'The rates are consistently better than other exchanges I\'ve tried. Plus the no-KYC policy is a huge plus for privacy-conscious users like me.',
      date: '1 week ago',
    },
    {
      name: 'David K.',
      role: 'Software Engineer',
      avatar: 'D',
      rating: 5,
      text: 'As a developer, I appreciate their API. Clean documentation, reliable endpoints, and great support. Built it into my app seamlessly.',
      date: '2 weeks ago',
    },
    {
      name: 'Emma T.',
      role: 'Investor',
      avatar: 'E',
      rating: 5,
      text: 'Customer support is incredible. Had an issue with a transaction and they resolved it within minutes via live chat. Highly recommended!',
      date: '3 weeks ago',
    },
  ];

  return (
    <section className="testimonials">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">
            <span className="label-dot" />
            Testimonials
          </span>
          <h2 className="section-title">
            Trusted by{' '}
            <span className="gradient-text">500,000+ Users</span>
          </h2>
          <p className="section-subtitle">
            See what our users are saying about their experience with Omini Bridge.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="quote-icon">
                <Quote />
              </div>
              
              <div className="testimonial-rating">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star key={i} className="star-icon" />
                ))}
              </div>

              <p className="testimonial-text">{testimonial.text}</p>

              <div className="testimonial-author">
                <div className="author-avatar">{testimonial.avatar}</div>
                <div className="author-info">
                  <span className="author-name">{testimonial.name}</span>
                  <span className="author-role">{testimonial.role}</span>
                </div>
                <span className="testimonial-date">{testimonial.date}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="trust-badges-row">
          <div className="trust-badge-item">
            <div className="trust-score">
              <span className="score">4.9</span>
              <div className="stars">
                <Star className="star-filled" />
                <Star className="star-filled" />
                <Star className="star-filled" />
                <Star className="star-filled" />
                <Star className="star-filled" />
              </div>
            </div>
            <span className="trust-source">TrustScore</span>
          </div>
          <div className="trust-divider" />
          <div className="trust-badge-item">
            <span className="trust-count">500K+</span>
            <span className="trust-source">Happy Users</span>
          </div>
          <div className="trust-divider" />
          <div className="trust-badge-item">
            <span className="trust-count">$2B+</span>
            <span className="trust-source">Volume Exchanged</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
